import { resolveSupplyChainPlan } from '../resolveSupplyChainPlan';
import type { SupplyChainPlan } from '../../types/supplyChain';
import type { SiteRagReport } from '../../types/siteRag';
import { createRegistryResolver, tierSource } from './resolveCore';
import type { RegistryResolver, ResolverFactoryOptions } from './types';

export interface SupplyChainResolverInput extends ResolverFactoryOptions {
  sitePlan?: SupplyChainPlan | null;
  report?: Pick<SiteRagReport, 'supplyChainPlanOverride' | 'supplyChainPlanAtGen'>;
  llmPlan?: Record<string, unknown>;
}

export function createSupplyChainResolver(opts: SupplyChainResolverInput): RegistryResolver {
  const { plan } = resolveSupplyChainPlan(opts.sitePlan, opts.report);
  const fieldSources: Record<string, ReturnType<typeof tierSource>[]> = {};

  if (plan) {
    const derived: Record<string, number> = {
      bomItemCount: plan.bom.length,
      supplierCount: plan.suppliers.length,
      quoteCount: plan.quotes.length,
    };
    for (const [key, val] of Object.entries(derived)) {
      fieldSources[key] = [
        tierSource(1, val, {
          kind: opts.report?.supplyChainPlanOverride ? 'report-override' : 'site-canonical',
          ref: `supplyChain:${key}`,
          label: 'Supply chain plan',
        }),
      ];
    }
  }

  for (const [key, val] of Object.entries(opts.llmPlan ?? {})) {
    if (val === undefined || val === null) continue;
    const sources = fieldSources[key] ?? [];
    sources.push(
      tierSource(3, val, {
        kind: 'llm-inference',
        ref: `llm:supplyChain:${key}`,
        label: 'LLM BoM inference',
      }),
    );
    fieldSources[key] = sources;
  }

  return createRegistryResolver({
    registryId: 'supplyChain',
    siteId: opts.siteId,
    fieldSources,
    now: opts.now,
  });
}
